import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useToast } from '@givebutter/primitives/toast';
import { generateExports } from 'api/contacts/exports';
import { ContactsViewContext } from 'assets/js/pages/contacts/ContactsViewContext';
import { useFiltersByKey } from 'components/filter/filters-next/useFiltersByKey';
import { ContactType } from 'constants/contacts';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const useExportContacts = (type = ContactType.Individual) => {
    const { accountId } = useCurrentAccount();
    const toast = useToast();
    const { archivedInput } = useContext(ContactsViewContext);
    const isArchived = archivedInput === 'archived';
    const resource = type === ContactType.Individual ? 'contacts' : 'companies';
    const { filters } = useFiltersByKey(resource);

    const { mutateAsync: exportContacts } = useMutation({
        mutationFn: () =>
            generateExports(accountId, {
                scope: 'all',
                object: 'account',
                report_type: 'csv',
                resource,
                object_id: accountId,
                filters,
                archived: isArchived,
            }),
        onError: () => {
            toast.error('Unable to generate report');
        },
    });

    return {
        exportContacts,
    };
};

export { useExportContacts };
